module.exports = __webpack_public_path__ + "img/image_desktop-AC.5d6d98b3.png";